import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.ProfileModule.actions.profile', {
    changePasswordMessage: 'Your password was updated.',
});
